import { ThemeSelectors } from "@at/design-system-foundation";
import styled from "styled-components";

export const DotsLoaderWrapper = styled.div`
  display: flex;
  margin: ${({ theme }) => ThemeSelectors.getGroupFourSpacing(theme)} 0
    ${({ theme }) => ThemeSelectors.getGroupFourSpacing(theme)} 0;

  > div {
    width: 8px;
    height: 8px;
    margin: 2px 2px 4px 2px;
    border-radius: 50%;
    background-color: ${({ theme }) => ThemeSelectors.getTitleColor(theme)};
    opacity: 0.2;
    animation: bouncing-loader 0.6s infinite alternate ease;
  }

  @keyframes bouncing-loader {
    to {
      opacity: 1;
    }
  }
  > div:nth-child(2) {
    animation-delay: 0.2s;
  }

  > div:nth-child(3) {
    animation-delay: 0.4s;
  }
`;
